import { render } from "./TaskCreator.vue?vue&type=template&id=ac762eb4"
import script from "./TaskCreator.vue?vue&type=script&lang=ts"
export * from "./TaskCreator.vue?vue&type=script&lang=ts"
script.render = render

export default script